module.exports = __webpack_public_path__ + "img/sbzc_05.aa0cae15.jpg";